import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCallCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 48" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#979797" transform="translate(1)">
      <path d="M35.069 30.06c0 6.222-3.353 9.97-7.05 13.838-3.696 3.868-7.84 2.948-11.194.552-3.352-2.395-7.808-6.292-7.808-12.988s5.343-7.09 12.192-9.49c4.566-1.6 7.307-3.848 8.221-6.747.8 1.523 2.047 2.766 3.741 3.73.847.565 1.898 2.02 1.898 4.391v6.714z" />
      <path d="M14.747 43.038c-1.465 1.679-3.617 2.518-6.455 2.518S2.698 44.441.023 42.21c3.141-3.168 4.712-6.415 4.712-9.741 0-4.99-2.391-7.83-2.391-14.442C2.344 11.414 6.33.604 21.119.604c4.875 0 7.811 2.489 9.238 4.979 3.685.096 12.206 2.976 12.206 10.935 0 1.63-.207 4.193-.62 7.689m-.614 10.111c-.552 2.864.235 4.895 2.36 6.094.911.5 1.963.848 3.156 1.044-1.542 2.734-4.527 4.1-8.954 4.1-4.428 0-7.525-.686-9.29-2.059" />
      <rect width={5} height={10} x={38.5} y={24.5} rx={2.5} />
      <path d="M41.177 34.599c.01 2.423-.39 4-1.202 4.729-1.218 1.094-2.55 1.094-5.103 1.094h-9.34" />
      <rect width={4} height={3} x={21.5} y={38.5} rx={1.5} />
    </g>
  </svg>
);
const Memo = memo(SvgCallCenter);
export default Memo;
